export enum StackPacksFilterStatus {
	AVAILABLE = "AVAILABLE",
	ENABLED = "ENABLED",
	BROKEN = "BROKEN",
	PENDING = "PENDING",
}

export interface StackPacksFilter {
	categories?: Array<string> | undefined;
	status?: StackPacksFilterStatus | undefined;
}
